<template> 
  <div>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    v-if="isMobileMode"
    color="#333"
    mobile-break-point="960"
    app
    :dark="isdark"
    width="260"
  > 
    <v-row>
      <v-col cols="2" offset-sm8>
      <v-btn icon small @click="drawer=false">
      <v-icon color="#eee" sm>
        mdi-code-less-than
      </v-icon> 
    </v-btn>
      </v-col>
    </v-row> 

    <v-list>
      <v-list-item class="px-4">
        <v-list-item-avatar>
          <img src="/favicon.png" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title class="body-1"><b></b></v-list-item-title>
          <v-list-item-subtitle class="body-2" style="margin-top:5px; color: #eee !important"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mb-2" />

    <v-list nav>  
      <template v-for="(item, i) in menuItems">
        <base-item-group color="primary--text" v-if="item.children" :key="`group-${i}`" :item="item"></base-item-group>
        <base-item v-else :key="`item-${i}`" :item="item" />
      </template> 
    </v-list> 

     <template v-slot:append>
        <div class="pa-2"> 
          <v-list dense nav class="py-0">
          <v-list-item >
            <v-list-item-icon>
              <v-icon>mdi-settings</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Preferences</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

          <br>
          <v-btn icon><v-icon>mdi-arrow-down-drop-circle</v-icon></v-btn>
        </div>
      </template>
  </v-navigation-drawer> 

  <div
      height="500"
      class="overflow-hidden vhlist" 
    >

      <ul style="list-style-type: none; margin: 0;padding: 0; width: 100%">
          <li style="background: #333; height: 40px;"> </li>
          <li style="background: #000; height: 40px;"> </li>
      </ul>
      <!-- <v-navigation-drawer 
        color="gray"   
        class="vhlist-tp" 
        :permanent="permanent"
        light
        dense
      > 
        <v-list
          dense
          nav
          class="py-0 pa-0 ma-0"
          style="border-radius: 0px"
        >

          <v-list-item two-line style="background: #333 !important">
            <v-list-item-avatar>
              <img src="https://randomuser.me/api/portraits/men/81.jpg">
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Application</v-list-item-title>
              <v-list-item-subtitle>Subtext</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> 

          <v-list-item two-line style="background: #000 !important">
            <v-list-item-content>
              <v-list-item-title>Application</v-list-item-title>
              <v-list-item-subtitle>Subtext</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> 

          <v-list-item
            v-for="item in items"
            :key="item.title"
            link
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>  
      </v-navigation-drawer> -->

      <v-divider></v-divider>
      <v-footer>
          <center><v-btn icon class="mr-2" color="primary"><v-icon medium>mdi-arrow-down-drop-circle</v-icon></v-btn></center>
      </v-footer>
    </div>

  </div>
</template>

<script>
// Utilities
import { mapState,mapMutations } from "vuex";

export default {
  name: "DashboardCoreDrawer", 
  data () {
      return { 
        items: [
          { title: 'Dashboard', icon: 'mdi-view-dashboard' },
          { title: 'Photos', icon: 'mdi-image' },
          { title: 'About', icon: 'mdi-help-box' },
        ],
        color: 'primary',
        colors: [
          'primary',
          'blue',
          'success',
          'red',
          'teal',
        ],
        right: false,
        permanent: true,
        miniVariant: false,
        expandOnHover: false,
        background: false,
        isdark: true
      }
    }, 
  computed: {
    ...mapState(["barColor","session","menuItems","isMobileMode"]),
    drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
    },
  },
  methods: {}
};
</script>

<style scoped>
.body-1 {
  word-spacing: 3px;
  letter-spacing: 1px;
  color: #878787 !important;
}

.body-2 {
  color: #464646 !important;
}
 
.vhlist{
  position: absolute;
  width: 250px;
  max-height: 500px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  top: 64px !important;
  left: 0;
  z-index: 1;
  background: #ddd !important;
}

.vhlist-tp{
  z-index: 2;
}

#poss{
  position: absolute;
  right: 2px;
  top: 20px
}
</style>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  .v-list-group__header.v-list-item--active:before
    opacity: .24

  .v-list-item
    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 20px

      +ltr()
      margin-right: 24px
      margin-left: 12px !important

      +rtl()
      margin-left: 24px
      margin-right: 12px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 10px

  .v-list-group--sub-group
    .v-list-item
      +ltr()
      padding-left: 8px

      +rtl()
      padding-right: 8px

    .v-list-group__header
      +ltr()
      padding-right: 0

      +rtl()
      padding-right: 0

      .v-list-item__icon--text
        margin-top: 19px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2

        +ltr()
        margin-right: 8px

        +rtl()
        margin-left: 8px
</style>
